import httpClient from '@/api/http-client';

const endpoint = 'api/locations-batch-jobs';

const locationBatchJobsService = {
  get: (params) => httpClient.get(endpoint, { params }),

  startBatchJob: (params) => httpClient.post(endpoint, params),

  endBatchJob: (params) => httpClient.post(`${endpoint}/finish-active-batch-job`, params),

  cancelBatchJob: (params) => httpClient.post(`${endpoint}/cancel-active-batch-job`, params),

  getActiveBatchJob: (params) => httpClient.get(`${endpoint}/${params.userCode}/active-batch-job`)
};

export default locationBatchJobsService;
